import React, { useEffect } from 'react';
import axios from "axios";
import { AppDatePicker } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from "../../../../../routing/helpers/router";

const Report32Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    selectedReport,
  } = props;

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 32,
        selectedReport,
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-lawFinder"
                name="module.lf.filter.from"
              />
            }
            value={values.from}
            onChange={(date) => handleOnSetFieldValue('from', date)}
            minDate={new Date(2021, 0, 1)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator file="module-lawFinder" name="module.lf.filter.to" />
            }
            value={values.to}
            onChange={(date) => handleOnSetFieldValue('to', date)}
            minDate={new Date(2021, 0, 1)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.to || !values.from}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report32Options;
